/** Human-readable labels for stable CMS item ids (order is fixed in the API). */
export const CMS_STABLE_ID_LABELS = {
  "rpm-ccm": "RPM & CCM",
  hipaa: "HIPAA compliant",
  encryption: "End-to-end encryption",
  realtime: "Real-time monitoring",
  devices: "Device integration",
  "vital-monitoring": "Vital monitoring",
  "mobile-app": "Patient mobile app",
  alerts: "Alerts",
  reports: "Reports",
  "care-plans": "Care plans",
  communication: "Communication",
  fax: "Fax",
  "hipaa-login": "HIPAA login",
  onboard: "Onboard",
  track: "Track",
  monitor: "Monitor",
  action: "Action",
  organizations: "Organizations",
  providers: "Providers",
  staff: "Staff",
  patients: "Patients",
  mission: "Our mission",
  "what-we-do": "What we do",
  "what-we-provide": "What we provide",
  rpm: "Remote patient monitoring",
  "care-management": "Care management",
  "patient-engagement": "Patient engagement",
  "operational-efficiency": "Operational efficiency",
  "rpm-simple": "RPM made simple",
  "care-coordination": "Care coordination",
  integrations: "Integrations",
  "blood-pressure-monitor": "Blood pressure monitor",
  "pulse-oximeter": "Pulse oximeter",
  "glucose-analyzer": "Glucose analyzer",
  "weight-scale": "Weight scale",
  phone: "Phone",
  email: "Email",
  headquarters: "Headquarters",
  fullName: "Full name",
  mobile: "Mobile",
  organization: "Organization",
  message: "Message",
};

const FIELD_SEGMENT_LABELS = {
  site: "Site",
  brand: "Brand",
  seo: "SEO",
  nav: "Navigation",
  footer: "Footer",
  home: "Home",
  about: "About",
  solutions: "Solutions",
  contact: "Contact",
  hero: "Hero",
  trustBar: "Trust bar",
  careChallenge: "Care challenge",
  features: "Features",
  howItWorks: "How it works",
  roleExperience: "Role experience",
  security: "Security",
  smartSolutions: "Smart solutions",
  alternatingFeatures: "Alternating features",
  integratedDevices: "Integrated devices",
  programCta: "Program CTA",
  messageSection: "Message section",
  infoCards: "Info cards",
  form: "Form",
  items: "Items",
  roles: "Roles",
  steps: "Steps",
  products: "Products",
  fields: "Fields",
  cta: "CTA",
  ctaBlock: "CTA block",
  challenge: "Challenge",
  platform: "Platform",
  headline: "Headline",
  prefix: "Prefix",
  highlight: "Highlight",
  rest: "Rest",
  description: "Description",
  title: "Title",
  label: "Label",
  href: "Link",
  backgroundImage: "Background image",
  sectionIcon: "Section icon",
  sectionTitle: "Section title",
  submitLabel: "Submit button",
  og: "Open Graph",
  twitter: "Twitter",
  keywords: "Keywords",
  contact: "Contact",
  appPromo: "App promo",
  link: "Link",
  links: "Links",
  badges: "Badges",
  image: "Image",
  icon: "Icon",
  paragraphs: "Paragraphs",
  bridgeText: "Bridge text",
};

function humanizeSegment(id) {
  if (!id) return "";
  const spaced = id
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[-_]/g, " ");
  return spaced.replace(/\b\w/g, (c) => c.toUpperCase());
}

export function getStableIdLabel(id) {
  if (!id) return "";
  return CMS_STABLE_ID_LABELS[id] || humanizeSegment(id);
}

export function formatFieldKey(fieldKey) {
  if (!fieldKey) return "";
  return fieldKey
    .split(".")
    .map((segment) => FIELD_SEGMENT_LABELS[segment] || humanizeSegment(segment))
    .join(" · ");
}
